'use strict';

/* global timeSPastMidnight */
angular.module('formApp').factory('elementHelper', [
  'mappings',
  function (mappings) {
    return {
      getType: function (element) {
        if (element.type !== undefined) {
          return element.type.toLowerCase();
        } else if (element.fields !== undefined && element.title !== undefined) {
          return 'media_accordion_element';
        } else if (element.fields !== undefined) {
          return 'row';
        } else if (element.rows !== undefined) {
          return 'fieldgroup';
        } else if (element["@type"] && element["@type"] === 'MediaAccordion') {
          return 'media_accordion';
        } else if (element.fieldGroups !== undefined) {
          return 'section';
        } else if (element.sections !== undefined) {
          return 'form';
        } else if (element.buttons !== undefined) {
          return 'custom_buttons';
        }
        throw 'Unknown Element Type';
      },
      getName: function (element) {
        var type = this.getType(element);
        if (type === 'form') {
          return 'Formular';
        } else if (type === 'fieldgroup') {
          return 'Feldgruppe';
        } else if (type === 'section') {
          return 'Bereich';
        } else if (type === 'custom_buttons') {
          return 'Schaltflächen';
        } else if (type === 'media_accordion') {
          return 'Medien-Akkordeon';
        } else if (type === 'media_accordion_element') {
          return 'Medien-Akkordeonelement';
        } else {
          return mappings.elements[type].label;
        }
      },
      addValue: function (element, value) {
        if (element.value === undefined) {
          element.value = [];
        }
        element.value.push(value);
      },
      removeValue: function (element, value) {
        var index = element.value.indexOf(value);
        element.value.splice(index, 1);
      },
      addPossibleValue: function (element, value) {
        if (element.possibleValues === undefined) {
          element.possibleValues = [];
        }
        if (value.helpDialog && !value.helpDialog.url) {
          delete value.helpDialog;
        }
        delete value.displayHelpDialog;
        element.possibleValues.push(value);
      },
      removePossibleValue: function (element, value) {
        var index = element.possibleValues.indexOf(value);
        element.possibleValues.splice(index, 1);
      },
      isPossibleValueSelected: function (element, possibleValue) {
        var selected = false;
        if (!element.value || !possibleValue) {
          return selected;
        }

        angular.forEach(element.value, function (value) {
          if (value === possibleValue.value) {
            selected = true;
          }
        });
        return selected;
      },
      toggleMultipleValue: function (element, value) {
        if (!element.value) {
          element.value = [];
        }
        var index = element.value.indexOf(value);
        if (index === -1) {
          element.value.push(value);
        } else {
          element.value.splice(index, 1);
        }
      },
      getValueType: function (element) {
        var elementType = this.getType(element);
        var valueType = mappings.elements[elementType].valueType;
        return valueType || 'none';
      },
      getUniqueFieldGroupTitle: function (fieldGroup) {
        return (fieldGroup.title || 'Unbenannte Gruppe') + ' (' + (fieldGroup.id || 'ID fehlt') + ')';
      },
      getUniqueFieldTitle: function (field) {
        var label = field.label || 'Unbenanntes Feld';
        if (field.type === 'TEXT') {
          label = 'Textanzeige';
        }
        return label + ' (' + (field.id || 'ID fehlt') + ')';
      },
      getAllowedDisplayConditions: function (element) {
        var elementType = this.getType(element);
        var conditions = [];
        var allowed = mappings.elements[elementType].allowedDisplayConditions || [];
        angular.forEach(allowed, function (conditionName) {
          var condition = mappings.displayConditions[conditionName];
          if (condition) {
            conditions.push(angular.copy(condition));
          }
        });
        return conditions;
      },
      getAllowedValidationRules: function (element) {
        var elementType = this.getType(element);
        var rules = [];
        var allowed = mappings.elements[elementType].allowedValidationRules || [];
        angular.forEach(allowed, function (ruleName) {
          var rule = mappings.validationRules[ruleName];
          if (rule) {
            rules.push(angular.copy(rule));
          }
        });
        return rules;
      },
      addConditionValue: function (condition, value) {
        if (condition.values === undefined) {
          condition.values = [];
        }
        condition.values.push(value);
      },
      removeConditionValue: function (condition, value) {
        var index = condition.values.indexOf(value);
        condition.values.splice(index, 1);
      },
      dropValue: function (dragStartIndex, dragEndIndex, value, values) {
        if (dragEndIndex !== -1) {
          if (dragEndIndex <= dragStartIndex) {
            dragStartIndex = dragStartIndex + 1;
          }
          values.splice(dragEndIndex, 0, value);
          values.splice(dragStartIndex, 1);
          return true;
        }
      },
      dragValueOver: function () {
        return true;
      },
      dragValueStart: function (index) {
        this.$scope.models.dragStartIndex = index;
      },
      isValueSelected: function (element, value) {
        if (this.getValueType(element) === 'single') {
          return element.value === value;
        } else {
          return element.value.indexOf && element.value.indexOf(value) !== -1;
        }
      },
      toggleSingleValue: function (element, value) {
        if (element.value === value) {
          element.value = undefined;
        } else {
          element.value = value;
        }
      },
      toggleValue: function (element, value) {
        if (this.getValueType(element) === 'single') {
          this.toggleSingleValue(element, value);
        } else {
          this.toggleMultipleValue(element, value);
        }
      }
    };
  }
]);
